<template lang="html">
  <section class="atlas-support">
    <div class="content">
      <div class="content-area">
        <img
          class="atlas-icon"
          :src="`${clientOrigin}/img/logo-atlas.png`"
          alt="Blackjack Atlas icon"
        />

        <h1 class="title">{{ atlasAppName }}</h1>
        <p>{{ atlasAppDescription }}</p>
      </div>
      <p class="contact-area">
        👋 Looking for help with the iOS or Android app? Please
        <a :href="supportMailTo">get in touch</a>.
      </p>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import RemoteLink from '@/components/RemoteLink';
import FormattedTable from '@/components/FormattedTable';
import {
  supportMailTo,
  atlasAppName,
  atlasAppDescription,
  clientOrigin,
} from '@/constants';

export default {
  name: 'About',

  data() {
    return {
      clientOrigin,
      supportMailTo,
      atlasAppName,
      atlasAppDescription,
    };
  },

  computed: {
    ...mapGetters(['currentUser']),
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/app-width';

.atlas-support {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.content {
  max-width: map-get($breakpoints, 'phone');
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
}

.content-area {
  flex-grow: 1;
}

.title {
  margin-top: 0.5em;
}

.contact-area {
  margin-bottom: 0;
}

.atlas-icon {
  max-width: 100px;
  border-radius: 0.4em;
  margin-top: 2em;
}

@media all and (min-width: map-get($breakpoints, 'phone')) {
  .content-area {
    flex-grow: initial;
  }
}
</style>
